<template>
  <main class="w-full bg-white h-screen">
    <slot />
  </main>
</template>
